<template>
  <div class="preika-auth-page">
    <div class="preika-auth-shell">
      <section class="preika-auth-brand">
        <img
          src="/img/avatars/preika_black.png"
          :alt="productName"
          class="preika-auth-brand__logo"
        >

        <div class="preika-auth-brand__content">
          <p class="preika-auth-brand__eyebrow">ACCOUNT RECOVERY</p>
          <h1>安全にアカウントを<br>再設定します。</h1>
          <p>
            ご本人確認用のURLを登録済みメールアドレスへ送信します。
            メールに記載された手順に沿って、新しいパスワードを設定してください。
          </p>
        </div>
      </section>

      <section class="preika-auth-form">
        <p class="preika-auth-form__eyebrow">RESET PASSWORD</p>
        <h2>パスワード再設定</h2>
        <p class="preika-auth-form__description">
          {{ productName }}に登録されているメールアドレスを入力してください。
        </p>

        <ValidationObserver ref="obs">
          <CForm @submit.prevent="sendMail">
            <div
              v-if="errors.length"
              class="alert alert-danger"
              role="alert"
            >
              <div
                v-for="error in errors"
                :key="error.error_id || error.error_name || error"
              >
                {{ error.error_name || error }}
              </div>
            </div>

            <ValidationProvider
              name="メールアドレス"
              rules="required|email|max:254"
              v-slot="providerProps"
              mode="aggressive"
            >
              <label for="preika-reset-email">メールアドレス</label>
              <CInput
                id="preika-reset-email"
                placeholder="name@example.com"
                autocomplete="username email"
                v-model="email"
                :is-valid="providerProps.errors.length ? false : null"
              >
                <template #prepend-content>
                  <CIcon name="cil-envelope-closed"/>
                </template>
              </CInput>
              <p v-if="providerProps.errors[0]" class="error">
                {{ providerProps.errors[0] }}
              </p>
            </ValidationProvider>

            <div class="preika-auth-form__actions">
              <router-link
                :to="{ name: 'Login' }"
                class="preika-auth-form__forgot"
              >
                ログイン画面へ戻る
              </router-link>

              <!--
                無効にするのは送信中だけ。入力の正しさは押されてから確かめる。

                以前は observerProps.validated も条件に入れていた。これは
                「検証を実行したか」であって「入力が正しいか」ではない。
                パスワードマネージャやブラウザの自動入力は input を出さない
                ので検証が走らず、**埋まって見えるのにボタンが押せない。**
                しかも invalid ではないから、赤字も1つも出ない。

                この流れは**リンクや申し込みに期限がある。**悩んでいるうちに
                切れると、最初からやり直しになる。

                Login.vue で同じ穴を直したときと同じ形に揃えてある。
              -->
              <save-button
                label="再設定メールを送信"
                loading-label="送信中"
                :loading="loading"
                :disabled="loading || !buttonFlg"
                @click="sendMail"
              />
            </div>
          </CForm>
        </ValidationObserver>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ConstList from './../../ConstList'
import SaveButton from '../../common/SaveButton'

import { PRODUCT_NAME } from '@/common/productName'

export default {
  name: 'SendEmail',

  computed: {
    /** 売るときの正式な表記。**1か所から取る。** */
    productName () {
      return PRODUCT_NAME
    }
  },

  components: {
    SaveButton
  },

  data () {
    return {
      email: '',
      errors: [],
      buttonFlg: true,
      loading: false
    }
  },

  methods: {
    /**
     * 自動入力された値を、こちらの持ち物へ写す。
     *
     * パスワードマネージャは input を出さずに欄を埋めることがある。
     * そのままだと v-model が空のまま送ってしまう。
     */
    syncAutofilledValues () {
      const emailField = document.getElementById('preika-reset-email')

      if (emailField && typeof emailField.value === 'string' && emailField.value !== this.email) {
        this.email = emailField.value
      }
    },
    async sendMail () {
      if (!this.buttonFlg || this.loading) return

      this.syncAutofilledValues()

      /*
       * ボタンを常に押せるようにした分、入力の確認はここで行う。
       * 自動入力で検証が走っていない場合も、押した時点で確かめられる。
       */
      const observer = this.$refs.obs
      if (observer) {
        const valid = await observer.validate()
        if (!valid) return
      }

      this.buttonFlg = false
      this.loading = true
      this.errors = []

      axios
        .post(process.env.VUE_APP_API_ORIGIN + '/send/mail', {
          email: this.email
        })
        .then(response => {
          if (response.data === ConstList.SUCCESS) {
            this.$router.push({
              name: 'ConfirmEmail',
              params: {
                email: this.email
              }
            })
            return
          }

          alert(ConstList.MAIL_ERROR)
          this.buttonFlg = true
        })
        .catch(error => {
          this.buttonFlg = true

          axios
            .post(
              process.env.VUE_APP_API_ORIGIN + '/error/frontError',
              { error: String(error) },
              {
                headers: {
                  'Content-Type': 'application/json'
                }
              }
            )
            .then(() => {
              alert(ConstList.SYSTEM_ERROR)
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR)
            })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
